import { KeyValue, KeyValuePipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { HistoryEntry, today } from '../model/history.model';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { TimelineEntryComponent } from '../timeline-entry/timeline-entry.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-timeline',
  template: `
    <div class="timeline">
      @for (record of timelineData | keyvalue : sortTimeline; track record; let isFirst = $first; let isLast = $last) {
      <mat-accordion>
        <mat-expansion-panel hideToggle [expanded]="isFirst">
          <mat-expansion-panel-header>
            <div class="timeline__item date-item dot-invisible">
              <mat-icon>expand_more</mat-icon>
              <div class="timeline__date">
                <div class="date-label">{{ record.key }}</div>
              </div>
              <div class="timeline__content">
                <span class="year-event-count">{{ record.value.length }} {{ 'building.history.events' | transloco }}</span>
              </div>
            </div>
          </mat-expansion-panel-header>
          @for (content of record.value; track content) { @if (content.type === 'typology') {
          <building-timeline-entry [typology]="content.data" [date]="content.date"></building-timeline-entry>
          } @if (content.type === 'control') {
          <building-timeline-entry [control]="content.data" [date]="content.date"></building-timeline-entry>
          } @if (content.type === 'status') {
          <building-timeline-entry [status]="content.data" [date]="content.date"></building-timeline-entry>
          } @if (content.type === 'itech') {
          <building-timeline-entry [itech]="content.data" [date]="content.date"></building-timeline-entry>
          } @if (content.type === 'ecab') {
          <building-timeline-entry [ecab]="content.data" [date]="content.date"></building-timeline-entry>
          } }
        </mat-expansion-panel>
      </mat-accordion>
      }
    </div>
  `,
  styleUrls: ['timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatIcon, TimelineEntryComponent, TranslocoPipe, KeyValuePipe],
})
export class TimelineComponent {
  @Input() timelineData: Map<string, HistoryEntry[]>;

  today = today;

  constructor() {}

  sortTimeline(a: KeyValue<string, HistoryEntry[]>, b: KeyValue<string, HistoryEntry[]>): number {
    return a.key === today ? 1 : b.key.localeCompare(a.key);
  }
}
